import { getGallery } from "./image-helpers";

const { getChapters } = require("api/services/chapters");
const { getHeadings } = require("api/services/headings");
const { getSubheadings } = require("api/services/subheadings");
const { checkIfPartsAreValid } = require("pages/home/Levels");

export function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

export function prepareItems(partitions = []) {
  if (Array.isArray(partitions)) {
    const flatItems = partitions.reduce(function flattenByGallery(
      items,
      partition
    ) {
      const gallery = getGallery(partition);

      const itemsMappedByGallery = gallery.map((image) => ({
        ...image.attributes,
        imagePath:
          process.env.REACT_APP_CMS_HOST +
          image.attributes?.formats?.thumbnail?.url,
        imageId: image.id,
        code: partition?.attributes?.code,
        description: partition?.attributes?.description,
        type: partition?.type,
      }));

      return items.concat(itemsMappedByGallery);
    },
    []);

    return flatItems;
  } else {
    return [];
  }
}

export function createPartQueries(parts, { signal } = {}) {
  const isValidParts = checkIfPartsAreValid(parts);

  if (!isValidParts) {
    return [];
  }

  const partitionQueryMap = {
    chapter: getChapters,
    heading: getHeadings,
    subheading: getSubheadings,
  };

  const queries = Object.keys(parts)
    .map((paritition) => {
      if (parts[paritition] && partitionQueryMap[paritition]) {
        return partitionQueryMap[paritition]({ signal }).then(
          function assignTypeToPartition({ data = {} }) {
            const partitionData = Array.isArray(data?.data)
              ? data.data.filter(Boolean)
              : [];

            return partitionData.map((chapter) => ({
              ...chapter,
              type: paritition,
            }));
          }
        );
      }
      return null;
    })
    .filter(Boolean);

  return queries;
}
